import React from 'react';
import styles from './style.module.scss';

const PowerappApprovalCard = ({ powerapp, onClick, isSelected, showArchived }) => {
  const getCountDisplay = () => {
    if (showArchived) {
      return {
        primary: powerapp.total_approvals || 0,
        secondary: `${powerapp.approved_count || 0} approved, ${powerapp.declined_count || 0} declined`
      };
    }
    return {
      primary: powerapp.pending_count || 0,
      secondary: `${powerapp.approved_count || 0} approved, ${powerapp.declined_count || 0} declined`
    };
  };

  const counts = getCountDisplay();
  const lastUpdated = showArchived
    ? powerapp.last_updated_ago
    : powerapp.manager_approval_created_at;

  return (
    <div
      className={`${styles.card} ${isSelected ? styles.selected : ""}`}
      onClick={onClick}
    >
      <div className={styles.card_left}>
        <div className={styles.card_content}>
          <div className={styles.dba_name}>{powerapp.powerapp_dba || "-"}</div>
          {showArchived && powerapp.organization_name && (
            <div className={styles.org_name}>{powerapp.organization_name}</div>
          )}
          <div className={styles.counts_text}>{counts.secondary}</div>
          {lastUpdated && (
            <div className={styles.last_updated}>Last updated: {lastUpdated}</div>
          )}
        </div>
      </div>
      <div className={styles.card_right}>
        <div className={styles.count_badge}>
          <span className={styles.count_number}>{counts.primary}</span>
          <span className={styles.count_label}>{showArchived ? 'Total' : 'Pending'}</span>
        </div>
      </div>
    </div>
  );
};

export default PowerappApprovalCard;
